import { Receipt } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/base/card';
import { explorerTxUrl } from '@/solana';
import { useAccount } from '@/state/account';

export function TransactionsCard() {
  const { txResults } = useAccount();
  if (txResults.length === 0) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="para:flex para:items-center para:gap-2">
          <Receipt className="para:size-5" />
          Transactions
        </CardTitle>
      </CardHeader>
      <CardContent className="para:flex para:flex-col para:gap-3">
        {txResults.map((r) => (
          <div key={r.signature} className="para:flex para:flex-col para:gap-1">
            <span className="para:text-xs para:uppercase para:tracking-wide para:text-muted-foreground">
              {r.kind === 'sol' ? 'SOL transfer' : 'SPL transfer'} ({r.network})
            </span>
            <a
              href={explorerTxUrl(r.signature, r.network)}
              target="_blank"
              rel="noreferrer"
              className="para:font-mono para:text-xs para:break-all para:underline para:underline-offset-2 para:hover:text-foreground"
            >
              {r.signature}
            </a>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
